/** Respuesta paginada del backend (`PageResponse`). `page` empieza en 0; `size` máximo 100. */
export interface PaginaRespuestaDto<T> {
  content: T[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
}

/** Tamaño máximo de página que acepta el backend (más de 100 responde 400). */
export const TAMANO_MAXIMO_PAGINA = 100;
